import React from 'react';
import styled from 'styled-components';

import PatternsButton from '../buttons/PatternsButton';
import Heading from '../heading/Heading';


const SewpatHeading = ({ title, designer, handleClick }) => {
    const StyledSewpatHeading = styled.div`
        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 2em;
        align-items: center;
        margin: 0 ${props => props.theme.space[8]} 0 ${props => props.theme.space[4]};
    `;

    return (
        <StyledSewpatHeading>
            <div>
                <Heading text={title} level={3} margin='0.5rem 0 0.1rem 0' />
                <Heading text={designer} level={6} margin='0 0 1rem 0' />
            </div>
            <PatternsButton handleClick={handleClick} />
        </StyledSewpatHeading>
    );
};

export default SewpatHeading;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatHeading.js